import { GoogleOAuthProvider } from '@react-oauth/google';
import { GoogleAnalyticsScreenContent } from './GoogleAnalyticsScreen';
import { config } from 'config';

export const GoogleAnalyticsScreen = () => {
  return (
    <GoogleOAuthProvider clientId={config.GOOGLE_AUTH_CLIENT_ID!}>
      <GoogleAnalyticsScreenContent />
    </GoogleOAuthProvider>
  );
};
